import React, { useState } from "react";

const CustomIcon = ({ icon: IconComponent, style, onClick, hoverColor }) => {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <IconComponent
      style={hovered ? { ...style, color: hoverColor } : style}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};

export default CustomIcon;